import { setSpecificMessage, octal } from "valibot";
setSpecificMessage(
  octal,
  (issue) => `Octet invalide: reçu ${issue.received}`,
  "fr"
);